import * as read_api from "./alan_api";
function serialize_id_path($_id_path: read_api.Cid_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_id_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no = $_id_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes = $_id_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_id_path($_yes.properties.tail);
				{
					let raw_type: Record<string, any>;
					switch ($_yes.properties.type.state.name) {
						case 'collection entry': {
							const $_collection_entry = $_yes.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["collection"] = $_collection_entry.properties.collection;
							raw_data["id"] = $_collection_entry.properties.id;
							raw_type = raw_data
							break;
						}
						case 'group': {
							const $_group = $_yes.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["group"] = $_group.properties.group;
							raw_type = raw_data
							break;
						}
						case 'state': {
							const $_state = $_yes.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["state"] = $_state.properties.state;
							raw_data["state group"] = $_state.properties.state_group;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes.properties.type.state)
					}
					raw_data["type"] = [$_yes.properties.type.state.name, raw_type];
				}
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_id_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_id_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
export function serialize($_application_identifier: read_api.Capplication_identifier) {
	const raw_data: Record<string, any> = {};
	raw_data["path"] = serialize_id_path($_application_identifier.properties.path);
	return raw_data;
}